import request from '@/utils/request';
import accountRequest from '@/utils/accountRequest';
import { getDeviceId } from '@/utils/auth';

/**
 * 登录
 * @returns
 */
export async function login(data) {
    const device_id = await getDeviceId();
    return accountRequest({
        url: `/v2/authorization`,
        method: 'post',
        data: { ...data, device_id, grant_type: 'password' },
    });
}

/**
 * 退出
 * @returns
 */

export async function logout() {
    const device_id = await getDeviceId();
    // const token = getToken();
    return accountRequest({
        url: `/logout?t=${new Date().getTime()}`,
        method: 'post',
        data: { device_id },
    });
}

/**
 * 字典
 * @returns
 */
export function getDict(type) {
    return request({
        url: `/dict/${type}`,
        method: 'get',
    });
}



// WEBPACK FOOTER //
// ./src/api/user.js